<template>
	<div>
        <div v-if="! complete">
            <slot></slot>

            <form @submit.prevent="submitForm">
                <div class="border-t border-gray-200 mt-10">
                    <div class="lg:w-1/2 mt-10">
                        <div class="flex items-center mt-2">
                            <form-toggle v-model="form.terms"></form-toggle>
                            <div class="ml-2">
                                I agree to the terms of the membership contract
                            </div>
                        </div>

                        <div class="ml-12 mt-1 text-xs text-red-600" v-if="hasError('terms')">
                            {{ getErrorFor('terms') }}
                        </div>

                        <form-input v-model="form.signed"
                                    label="Signed (Type Full Name)"
                                    required
                                    class="mt-6"
                                    :error="getErrorFor('signed')"
                        ></form-input>

                        <div class="flex justify-end mt-6">
                            <form-button type="submit">
                                Sign Contract
                            </form-button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="space-y-6"
             v-else
        >
            <p>
                Thank you for completing your membership contract. Your Membership is now active and you can begin
                making bookings.
            </p>

            <p>
                If you are paying monthly, please ensure you set up your Standing Order immediately using the banking
                details provided in your email confirmation.
            </p>

            <p>
                Please contact us on 01473 - 375 026 should you have any questions at all. We look forward to welcoming
                you to your first event.
            </p>
        </div>
    </div>
</template>

<script>
    import FormInput from "../../../components/form/Input";
    import FormToggle from "../../../components/form/public/Toggle";
    import FormButton from "../../../components/form/Button";

    import Form from "../../../mixins/Form";

	export default {
		data() {
		    return {
		        complete: false,

                form: {
		            terms: false,
                    signed: '',
                }
            }
        },

        components: { FormInput, FormToggle, FormButton },

        mixins: [Form],

        methods: {
		    submitForm() {
		        this.patch(route('customer.membership.contract.sign').url())
                    .then(() => {
                        this.complete = true;
                    })
            }
        }
	}
</script>
